// extracted by mini-css-extract-plugin
export default {"ornamentations":"s44yqW","leftFirst":"l7QnYM","rightFirst":"TD5lbf","responsiveImage":"EZodlK"};